import { getAxiosFulfilledState, getPendingState, getRejectedState, resetState } from '../helpers/reducerHelper'
import { IReduxAction } from './index'
import { DataPromise } from '../context/AxiosContext'
import { ListItemDto, PartyAction, PartyOverviewItemDto } from '../config/partyConfig'
import { ActionType } from 'redux-promise-middleware'

export interface IPartyState {
    overview: DataPromise<PartyOverviewItemDto[]>
    list: DataPromise<ListItemDto[]>
}

const defaultState: IPartyState = {
    overview: {
        data: null,
        loaded: false,
        loading: false,
    },
    list: {
        data: [],
        loaded: false,
        loading: false,
    },
}

export default function reducer(state: IPartyState = defaultState, action: IReduxAction): IPartyState {
    switch (action.type) {
        case `${PartyAction.GetOverview}_${ActionType.Pending}`: {
            return getPendingState(state, 'overview')
        }
        case `${PartyAction.GetOverview}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'overview')
        }
        case `${PartyAction.GetOverview}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'overview')
        }
        case `${PartyAction.GetList}_${ActionType.Pending}`: {
            return getPendingState(state, 'list')
        }
        case `${PartyAction.GetList}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'list')
        }
        case PartyAction.Reset: {
            return resetState(state, { overview: null, list: [] })
        }
    }

    return state
}
